/** Every namespace, in both languages. Bundled: two languages are small, and
 * a lazy load would flash English before French on every cold start. */
import enCommon from "./locales/en/common";
import enShell from "./locales/en/shell";
import enAuth from "./locales/en/auth";
import enLibrary from "./locales/en/library";
import enRecording from "./locales/en/recording";
import enAi from "./locales/en/ai";
import enStudio from "./locales/en/studio";
import enSettings from "./locales/en/settings";
import enAdmin from "./locales/en/admin";
import frCommon from "./locales/fr/common";
import frShell from "./locales/fr/shell";
import frAuth from "./locales/fr/auth";
import frLibrary from "./locales/fr/library";
import frRecording from "./locales/fr/recording";
import frAi from "./locales/fr/ai";
import frStudio from "./locales/fr/studio";
import frSettings from "./locales/fr/settings";
import frAdmin from "./locales/fr/admin";

export const en = {
  common: enCommon,
  shell: enShell,
  auth: enAuth,
  library: enLibrary,
  recording: enRecording,
  ai: enAi,
  studio: enStudio,
  settings: enSettings,
  admin: enAdmin,
};

export const fr = {
  common: frCommon,
  shell: frShell,
  auth: frAuth,
  library: frLibrary,
  recording: frRecording,
  ai: frAi,
  studio: frStudio,
  settings: frSettings,
  admin: frAdmin,
};

/**
 * Give every French plural a `_many` form.
 *
 * French has a third plural category — "many", for numbers like 1 000 000 —
 * and i18next does not fall back from it to `_other`: with only `_one` and
 * `_other` it rendered the raw key ("v") for a million. French uses the
 * `_other` wording there, so it is copied rather than asked of every author.
 */
function withManyForms<T>(tree: T): T {
  if (typeof tree !== "object" || tree === null) return tree;
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(tree)) {
    out[key] = withManyForms(value);
    if (key.endsWith("_other")) {
      const many = `${key.slice(0, -"_other".length)}_many`;
      if (!(many in (tree as Record<string, unknown>))) out[many] = value;
    }
  }
  return out as T;
}

export const resources = { en, fr: withManyForms(fr) };
export const NAMESPACES = Object.keys(en) as Array<keyof typeof en>;
